export const CHAT_MOBILE_HEADER_HEIGHT = "72px";
export const CHAT_DESKTOP_HEADER_HEIGHT = "88px";
export const CHAT_DESKTOP_HEADER_BREAKPOINT = "800px";
export const CHAT_TIMELINE_VERTICAL_GUTTER = "16px";
